import { TelemetryClientEnvironment } from "@shapr3d/frontend-lib";

export enum Environment {
  PROD = "prod",
  BETA = "beta",
  STAGE = "stage",
  DEV = "dev",
}

let domain = "shapr3d.com";
let url = "https://sync.api.shapr3d.com";
let UMCURL = "https://account.shapr3d.com";
let WVURL = "https://collaborate.shapr3d.com";
let UMSURL = "https://prod.api.shapr3d.com/user-management";
let env = Environment.PROD;
let flagsmithEnvironmentId = "CuoS4dvojMMqZuo76hogNA";
let telemetryEnv = TelemetryClientEnvironment.PROD;
const GTM_PROD_URL = "https://www.googletagmanager.com/gtm.js?id=GTM-5W7ZGHPW";
const GTM_STAGE_URL = "https://www.googletagmanager.com/gtm.js?id=GTM-5T7679LW";
let tagmanagerUrl = GTM_PROD_URL;

if (import.meta.env.VITE_APP_ENV === "stage") {
  url = "https://stage.sync.api.shapr3d.com";
  UMCURL = "https://stage.user.shapr3d.com";
  UMSURL = "https://stage.api.shapr3d.com/user-management";
  WVURL = "https://stage.collaborate.shapr3d.com";
  env = Environment.STAGE;
  telemetryEnv = TelemetryClientEnvironment.STAGE;
  flagsmithEnvironmentId = "9HzvDVezeg48Yexn3c83Db";
  tagmanagerUrl = GTM_STAGE_URL;
} else if (import.meta.env.VITE_APP_ENV === "beta") {
  url = "https://beta.sync.api.shapr3d.com";
  UMCURL = "https://account.shapr3d.com";
  UMSURL = "https://prod.api.shapr3d.com/user-management";
  WVURL = "https://beta.collaborate.shapr3d.com";
  env = Environment.BETA;
  telemetryEnv = TelemetryClientEnvironment.BETA;
  tagmanagerUrl = GTM_STAGE_URL;
} else if (import.meta.env.VITE_APP_ENV === "local") {
  domain = "localhost";
  url = "http://localhost:3100";
  UMCURL = "http://localhost:3002";
  UMSURL = "http://localhost:3000";
  WVURL = "http://localhost:3200";
  env = Environment.DEV;
  telemetryEnv = TelemetryClientEnvironment.DEV;
  flagsmithEnvironmentId = "9HzvDVezeg48Yexn3c83Db";
  tagmanagerUrl = GTM_STAGE_URL;
}

export const telemetryClientEnvironment = telemetryEnv;
export const environment = env;
export const SyncAPIURL = url;
export const accountURL = UMCURL;
export const UMSAPIURL = UMSURL;
export const webViewURL = WVURL;
export const marketingSiteURL = "https://www.shapr3d.com";

export const trackingIDHeaderName = "x-shapr-user-tracking-id";
export const appVersionHeaderName = "x-shapr-app-version";
export const defaultTeamSpaceName = "Untitled Space";
export const defaultPrivateSpaceName = "Drafts";

export const SENTRY_DSN =
  "https://bc6cade39ab9433d94d13ea27dfaf5b9@o396075.ingest.sentry.io/6608318";

export const GTMURL = tagmanagerUrl;

export const remoteConfigEnvironmentId = flagsmithEnvironmentId;
export const remoteConfigTimeoutMS = 1500;
export const cookieDomain = domain;

export const PostMessages = {
  LogoutFinished: "LOGOUT_FINISHED",
} as const satisfies { [key in string]: Parameters<typeof postMessage>[0] };

export const CollaborationPromoURL =
  "https://support.shapr3d.com/hc/en-us/articles/7874521411612-Webviewer";

export const localStorageKeys = {
  isDeepLinkAutoOpenEnabled: "deepLinkAutoOpen",
} as const;
